import { API_BASE_URL } from "../../constants/index"; // Base URL for the API
import HttpInterface from "../../helpers/HttpInterface"; // Helper class for making HTTP requests
import { defaultFetchParam, FetchParam } from "../../Models/FetchParam"; // Fetch parameters model and default values
import { LogisticIntegration } from "../../Models/LogisticIntegration"; // Logistic integration model
import { PaginatedResponse } from "../../Models/Pagination"; // Pagination model to handle paginated responses
import { buildAPIUrl } from "../../utilities/api"; // Utility function to build the API URL with query parameters

export class LogisticIntegrationsService {
  private httpProxy: HttpInterface; // Instance of the HttpInterface to make HTTP requests

  // Constructor initializes the httpProxy with the HttpInterface
  constructor() {
    this.httpProxy = new HttpInterface(); // Creates an instance of the HttpInterface to handle requests
  }

  /**
   * Fetches all logistic integrations from the logistic service API.
   *
   * @param params The query parameters for the API request. Defaults to `defaultFetchParam` if not provided.
   * @returns A promise that resolves with the API response containing the paginated list of logistic integrations.
   */
  all(
    params: FetchParam = defaultFetchParam
  ): Promise<{ data: PaginatedResponse<LogisticIntegration> }> {
    const requestOptions = {
      method: "GET", // HTTP method for the request
    };

    // Builds the complete API URL using the base URL, endpoint, and parameters
    return this.httpProxy.fetch(
      buildAPIUrl(
        `${API_BASE_URL}/logistic-service/logistic-integrations`,
        params
      ),
      requestOptions
    );
  }

  /**
   * Fetches a single logistic integration by its ID from the API.
   *
   * @param id The unique identifier of the logistic integration to fetch.
   * @returns A promise that resolves with the API response containing the logistic integration details.
   */
  get(id: string): Promise<LogisticIntegration> {
    const requestOptions = {
      method: "GET", // HTTP method for the request
    };

    // Constructs the URL for fetching a specific logistic integration by its ID
    return this.httpProxy.fetch(
      `${API_BASE_URL}/logistic-service/logistic-integrations/${id}`,
      requestOptions
    );
  }
}
